import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import { TimelineMax, TweenMax } from 'gsap';

import style from './index.module.scss';

export default class CTA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false
    }

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleAnimationComplete = this.handleAnimationComplete.bind(this);
    this.handleReverseComplete = this.handleReverseComplete.bind(this);
  }

  animateIn() {
    this.tl.play();
  }

  animateOut() {
    this.tl.reverse(0, true);
  }

  handleAnimationComplete() {
    this.setState(() => ({ active: true }));
  }

  handleReverseComplete() {
    const { show } = this.props;
    if (!show) return;
    this.setState(() => ({ active: true }));
  }

  handleMouseEnter(e) {
    const { show, primaryColor, secondaryColor } = this.props;
    const { active } = this.state;

    if (!show || !active) return;
    TweenMax.to(this.rectangle, 0.5, { css: { background: primaryColor, textDecoration: 'none', color: secondaryColor } });
  }

  handleMouseLeave(e) {
    const { show, primaryColor, secondaryColor } = this.props;
    const { active } = this.state;
    if (!show || !active) return;
    TweenMax.to(this.rectangle, 0.5, { css: { background: secondaryColor, textDecoration: 'none', color: primaryColor } });
  }

  componentDidMount() {
    const { delay } = this.props;
    this.tl = new TimelineMax({ paused: true, delay, onComplete: this.handleAnimationComplete, onReverseComplete: this.handleReverseComplete });
  }
  
  render() {
    const { text, className, show, styles, secondaryColor } = this.props;

    return (
      <Transition
          timeout={0}
          in={show}
          addEndListener={(node, done) => {
            show ? this.animateIn() : this.animateOut();
          }}
        >

        <div className={`${style.container} ${className}`}
          ref={instance => this.container = instance}
          onMouseOver={this.handleMouseEnter} onMouseOut={this.handleMouseLeave}
          onClick={this.props.onClick.bind(this)}>
          <div className={style.rectangle} ref={instance => this.rectangle = instance} style={Object.assign({}, {
            ...styles,
            backgroundColor: secondaryColor
          })}>
            <div className={style.text} color={secondaryColor} ref={instance => this.text = instance}>{text}</div>
          </div>
        </div>
      </Transition>
      
    )
  }
}
